const megaOpenSearch = document.querySelector('.mega-navigation #openSearch');
const megaNavItems = document.querySelector('.mega-navigation-items');
const megaNavSearchResults = document.querySelector('.mega-navigation .search_btn');
const megaNavInputSearch = document.querySelector('.mega-navigation #searchInput');
const mobileExpandButton = document.querySelector('.mobile-expand button');
const mainItems = document.querySelectorAll('.mega-navigation .mega-navigation__menu--parent');
const mainChildItems = document.querySelectorAll('.mega-navigation-child-wrapper');
const mobileSearchForm = document.querySelector('.mobile-search-container form');
const mobileSearchFormInput = document.querySelector('.mobile-search-container input');

const init = (() => {
    MegaNavigationHoverHandler();

    $('.mobile-expand button').on('click', function () {
        $(this).toggleClass('is-active');
    });

    if (mobileExpandButton)
        mobileExpandButton.addEventListener("click", (event) => {
            let body = document.querySelector('.mega-navigation-mobile-content-child-body');

            if (event.target.dataset.isActive == 'false') {
                event.target.dataset.isActive = true;
                body.classList.remove('d-none');
            } else {
                event.target.dataset.isActive = false;
                body.classList.add('d-none');
            }
        });

    if (megaOpenSearch)
        megaOpenSearch.addEventListener('click', (event) => {
            megaNavItems.classList.add('mega-navigation-items--search');
        });

    if (megaNavSearchResults)
        megaNavSearchResults.addEventListener('click', (event) => {
            megaNavItems.classList.remove('mega-navigation-items--search');
        });

    if (megaNavInputSearch)
        megaNavInputSearch.addEventListener('keypress', (event) => {
            if (event.keyCode == 13 && event.target.value !== '') {
                redirectSearch(event.target.value);
            }
        });

    if (mobileSearchForm)
        mobileSearchForm.addEventListener("submit", (event) => {
            event.preventDefault();
            if (mobileSearchFormInput && mobileSearchFormInput.value !== '')
            {
                redirectSearch(mobileSearchFormInput.value);
            }
        });
})();

function redirectSearch(parameters) {
    const url = '/search?searchTerms=' + parameters;
    window.location = url;
}

function addMegaMenuHover(event) {
    const allFolders = document.querySelectorAll(`.mega-navigation-child-wrapper[data-folder]`);
    for (let i = 0; i < allFolders.length; i++) {
        const folder = allFolders[i];
        if (folder.dataset.folder == event.target.dataset.folder) {
            folder.classList.remove('d-none');
            folder.classList.add('d-block');
        } else {
            folder.classList.add('d-none');
            folder.classList.remove('d-block');
        }
    }
}

function removeMegaMenuHover(event) {
    const elements = document.querySelectorAll('.mega-navigation-child-wrapper');
    for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        element.classList.remove('d-block');
        element.classList.add('d-none');
    }
}

function ChatGpt3Function() {
    // Get all the elements with the class "mega-navigation__menu--parent"
    const parentElements = document.querySelectorAll('.mega-navigation__menu--parent');

    // Loop through all the parent elements
    parentElements.forEach(parentElement => {

        // Add a mouseover event listener to each parent element
        parentElement.addEventListener('mouseover', () => {

            // Get the value of the data-folder attribute of the parent element
            const dataFolderValue = parentElement.getAttribute('data-folder');

            // Get all the child elements with the class "mega-navigation-child-wrapper"
            const childElements = document.querySelectorAll('.mega-navigation-child-wrapper');

            // Loop through all the child elements
            childElements.forEach(childElement => {

                // Check if the child element has the same value of data-folder attribute as the parent element
                if (childElement.getAttribute('data-folder') === dataFolderValue) {

                    // If the child element has the same value of data-folder attribute as the parent element, set its class to "d-block"
                    childElement.classList.remove('d-none');
                    childElement.classList.add('d-block');

                } else {

                    // If the child element has a different value of data-folder attribute as the parent element, set its class to "d-none"
                    childElement.classList.remove('d-block');
                    childElement.classList.add('d-none');
                }
            });
        });
    });

    // Add a mouseover event listener to the document
    document.addEventListener('mouseover', (event) => {

        // Get the target element of the mouseover event
        const targetElement = event.target;

        const navItems = document.querySelector('.mega-navigation-menu ul');
        const childItems = document.querySelector('.mega-navigation-child-wrapper-container');

        // Check if the target element is not a child of an element with the class "mega-navigation-menu" and is not a "mega-navigation-child-wrapper" element itself
        if (!navItems.contains(targetElement) && !childItems.contains(targetElement)) {
            console.log(targetElement)
            // Get all the child elements with the class "mega-navigation-child-wrapper"
            const childElements = document.querySelectorAll('.mega-navigation-child-wrapper');

            // Loop through all the child elements
            childElements.forEach(childElement => {

                // Remove the class "d-block" from all the child elements
                childElement.classList.remove('d-block');
                childElement.classList.add('d-none');
            });
        }
    });
}

function MegaNavigationHoverHandler() {
    const megaNavParentItems = document.querySelectorAll('.mega-navigation__menu--parent');
    const megaNavChildWrapperItems = document.querySelectorAll('.mega-navigation-child-wrapper');
    const megaNavMenu = document.querySelector('.mega-navigation-menu ul');
    const megaNavChildWrapperContainer = document.querySelector('.mega-navigation-child-wrapper-container');

    function hideAllMegaNavChildWrapperItems() {
        megaNavChildWrapperItems.forEach(item => {
            item.classList.remove('d-block');
            item.classList.add('d-none');
        });
    }

    function showMegaNavChildWrapperItem(folderName) {
        const targetElement = document.querySelector(`.mega-navigation-child-wrapper[data-folder="${folderName}"]`);
        if (targetElement) {
            targetElement.classList.remove('d-none');
            targetElement.classList.add('d-block');
        }
    }

    megaNavParentItems.forEach(item => {
        item.addEventListener('mouseover', () => {
            const folderName = item.getAttribute('data-folder');
            hideAllMegaNavChildWrapperItems();
            showMegaNavChildWrapperItem(folderName);
        });
    });

    document.addEventListener('mouseover', (event) => {
        const target = event.target;
        if (megaNavMenu && !megaNavMenu.contains(target) && !megaNavChildWrapperContainer.contains(target)) {
            hideAllMegaNavChildWrapperItems();
        }
    });
}